export default __webpack_public_path__ + "static/media/brilliant_diamond_fragment.8aa3f767.png";